(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bakuna-guide-ph"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-bakuna-guide]';

    const manilaDate = () => {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Manila',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      const value = Object.fromEntries(parts.map((part) => [part.type, part.value]));
      return `${value.year}-${value.month}-${value.day}`;
    };

    const ageFromDate = (birthDate, todayDate) => {
      const birth = birthDate.split('-').map(Number);
      const today = todayDate.split('-').map(Number);
      if (birth.length !== 3 || birth.some(Number.isNaN)) return null;
      const birthUtc = Date.UTC(birth[0], birth[1] - 1, birth[2]);
      const todayUtc = Date.UTC(today[0], today[1] - 1, today[2]);
      const normalizedBirth = new Date(birthUtc);
      if (
        normalizedBirth.getUTCFullYear() !== birth[0] ||
        normalizedBirth.getUTCMonth() !== birth[1] - 1 ||
        normalizedBirth.getUTCDate() !== birth[2]
      ) return null;
      const days = Math.floor((todayUtc - birthUtc) / 86400000);
      let months = (today[0] - birth[0]) * 12 + today[1] - birth[1];
      if (today[2] < birth[2]) months -= 1;
      if (days < 0 || months < 0) return null;
      return { days, months, years: Math.floor(months / 12), remainingMonths: months % 12 };
    };

    const stageFromAge = (stages, age) => stages.find((stage) => {
      if (Number.isFinite(stage.minDays) && age.days < stage.minDays) return false;
      if (Number.isFinite(stage.maxDays) && age.days > stage.maxDays) return false;
      if (Number.isFinite(stage.minMonths) && age.months < stage.minMonths) return false;
      if (Number.isFinite(stage.maxMonths) && age.months > stage.maxMonths) return false;
      return true;
    });

    const addListItems = (list, items) => {
      list.replaceChildren(...items.map((item) => {
        const li = document.createElement('li');
        li.textContent = item;
        return li;
      }));
    };

    const init = (root) => {
      if (root.dataset.bakunaReady === 'true') return;
      const dataNode = root.querySelector('[data-bakuna-guide-data]');
      if (!dataNode) return;
      let data;
      try {
        data = JSON.parse(dataNode.textContent);
      } catch (_error) {
        return;
      }
      const copy = data.copy;
      const form = root.querySelector('[data-bakuna-profile-form]');
      const dob = root.querySelector('[data-bakuna-dob]');
      const stageSelect = root.querySelector('[data-bakuna-stage]');
      const gradeSelect = root.querySelector('[data-bakuna-grade]');
      const error = root.querySelector('[data-bakuna-form-error]');
      const results = root.querySelector('[data-bakuna-results]');
      const ageHeading = root.querySelector('[data-bakuna-age-heading]');
      const status = root.querySelector('[data-bakuna-status]');
      const decision = root.querySelector('[data-bakuna-decision]');
      const expected = root.querySelector('[data-bakuna-expected]');
      const recordSummary = root.querySelector('[data-bakuna-record-summary]');
      const riskSummary = root.querySelector('[data-bakuna-risk-summary]');
      const recordList = root.querySelector('[data-bakuna-record-list]');
      const visitList = root.querySelector('[data-bakuna-visit-list]');
      const announcer = root.querySelector('[data-bakuna-announcer]');
      const steps = [...root.querySelectorAll('[data-bakuna-step]')];
      const printButton = root.querySelector('[data-bakuna-print]');
      const resetButton = root.querySelector('[data-bakuna-reset]');
      if (![copy, form, dob, stageSelect, gradeSelect, error, results, ageHeading, status, decision, expected, recordSummary, riskSummary, recordList, visitList, announcer, printButton, resetButton].every(Boolean)) return;
      root.dataset.bakunaReady = 'true';
      let currentStage = null;
      let currentRecordState = null;
      let currentRiskState = null;
      let currentSchoolGrade = null;

      dob.max = manilaDate();

      dob.addEventListener('input', () => {
        if (dob.value) stageSelect.value = '';
      });

      stageSelect.addEventListener('change', () => {
        if (stageSelect.value) dob.value = '';
      });

      const formatAge = (age) => {
        const yearLabel = age.years === 1 ? copy.year : copy.years;
        const monthLabel = age.remainingMonths === 1 ? copy.month : copy.months;
        if (age.years > 0) return `${age.years} ${yearLabel}, ${age.remainingMonths} ${monthLabel}`;
        return `${age.months} ${age.months === 1 ? copy.month : copy.months}`;
      };

      const setStep = (stepNumber) => {
        steps.forEach((step) => {
          const isCurrent = Number(step.dataset.bakunaStep) === stepNumber;
          step.classList.toggle('is-active', isCurrent);
          if (isCurrent) step.setAttribute('aria-current', 'step');
          else step.removeAttribute('aria-current');
        });
      };

      const showError = (message, target = dob) => {
        error.textContent = message;
        error.hidden = false;
        target.focus();
      };

      const updateVisitPlan = () => {
        const items = [];
        let unanswered = 0;
        if (currentRecordState !== 'with') items.push(copy.visitRecord);
        const recordSelects = [...recordList.querySelectorAll('select')];
        recordSelects.forEach((select) => {
          if (!select.value) unanswered += 1;
          if (select.value === 'not_sure' || select.value === 'not_listed') {
            items.push(`${copy.visitUnknown}: ${select.dataset.label}`);
          }
        });
        if (unanswered > 0) items.push(`${copy.visitUnanswered}: ${unanswered}`);
        if (currentRiskState !== 'no') {
          items.push(copy.visitRisk, ...currentStage.risks);
        }
        if (currentSchoolGrade === 'grade_1') {
          items.push(currentStage.id === 'four_six' ? copy.gradeOneUnderSeven : copy.gradeOneSevenPlus);
        } else if (currentSchoolGrade === 'grade_4') {
          items.push(copy.gradeFour);
        } else if (currentSchoolGrade === 'grade_7') {
          items.push(copy.gradeSeven);
        } else if (currentSchoolGrade === 'other' || currentSchoolGrade === 'unsure') {
          items.push(copy.gradeOther);
        }
        addListItems(visitList, [...new Set(items)]);
        setStep(recordSelects.some((select) => select.value) ? 3 : 2);
      };

      const buildRecordList = () => {
        const rows = currentStage.records.map((label, index) => {
          const row = document.createElement('div');
          row.className = 'bakuna-guide__record-row';
          const fieldLabel = document.createElement('label');
          const id = `${root.id}-record-${index}`;
          fieldLabel.htmlFor = id;
          fieldLabel.textContent = label;
          const select = document.createElement('select');
          select.id = id;
          select.dataset.label = label;
          [
            ['', copy.choose],
            ['documented', copy.documented],
            ['not_sure', copy.notSure],
            ['not_listed', copy.notListed]
          ].forEach(([value, text]) => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = text;
            select.append(option);
          });
          select.addEventListener('change', updateVisitPlan);
          row.append(fieldLabel, select);
          return row;
        });
        recordList.replaceChildren(...rows);
      };

      const render = (stage, age, recordState, riskState, schoolGrade) => {
        currentStage = stage;
        currentRecordState = recordState;
        currentRiskState = riskState;
        currentSchoolGrade = schoolGrade;
        const heading = age ? `${copy.agePrefix} ${formatAge(age)} · ${stage.title}` : stage.title;
        ageHeading.textContent = heading;
        status.textContent = riskState === 'no' ? copy.recordReview : copy.clinicianReview;
        status.classList.toggle('is-risk', riskState !== 'no');
        const baseDecision = recordState === 'with' ? copy.decisionWith : recordState === 'partial' ? copy.decisionPartial : copy.decisionNone;
        decision.textContent = riskState === 'no' ? baseDecision : `${baseDecision} ${copy.decisionRisk}`;
        expected.textContent = stage.expected;
        addListItems(recordSummary, stage.records);
        addListItems(riskSummary, stage.risks);
        buildRecordList();
        updateVisitPlan();
        results.hidden = false;
        announcer.textContent = `${status.textContent}. ${heading}`;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        results.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        ageHeading.focus({ preventScroll: true });
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        error.hidden = true;
        if (!form.reportValidity()) return;
        const formData = new FormData(form);
        const birthDate = formData.get('dob');
        const selectedStage = formData.get('stage');
        const recordState = formData.get('record_state');
        const riskState = formData.get('risk_state');
        const schoolGrade = formData.get('school_grade');
        let age = null;
        let stage = null;

        if (birthDate) {
          age = ageFromDate(String(birthDate), manilaDate());
          if (!age) {
            showError(copy.invalidDob);
            return;
          }
          stage = stageFromAge(data.stages, age);
          if (!stage) {
            showError(copy.outside);
            return;
          }
          stageSelect.value = stage.id;
        } else if (selectedStage) {
          stage = data.stages.find((item) => item.id === selectedStage);
        }

        if (!stage) {
          showError(copy.formError);
          return;
        }

        const runRender = () => render(stage, age, recordState, riskState, schoolGrade);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !reducedMotion) document.startViewTransition(runRender);
        else runRender();
      });

      printButton.addEventListener('click', () => window.print());
      resetButton.addEventListener('click', () => {
        form.reset();
        stageSelect.value = '';
        gradeSelect.value = '';
        recordList.replaceChildren();
        visitList.replaceChildren();
        results.hidden = true;
        error.hidden = true;
        announcer.textContent = '';
        setStep(1);
        dob.focus();
      });
    };

    document.querySelectorAll(selector).forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll(selector).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jho-booking-form"] && !Shopify.designMode) return;
  try {
    
  const initializeBookingForms = (root = document) => {
    root.querySelectorAll('[data-jho-booking]').forEach((section) => {
      if (section.dataset.bookingReady === 'true') return
      section.dataset.bookingReady = 'true'

      const today = new Date()
      const localToday = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0, 10)

      section.querySelectorAll('[data-booking-future-date]').forEach((input) => {
        input.min = localToday
      })

      const form = section.querySelector('form')
      const honeypot = section.querySelector('[data-booking-honeypot]')
      const botStatus = section.querySelector('[data-booking-bot-status]')

      if (form && honeypot && botStatus) {
        form.addEventListener('submit', (event) => {
          if (honeypot.value.trim() === '') return
          event.preventDefault()
          form.reset()
          botStatus.hidden = false
          botStatus.focus()
        })
      }

      const success = section.querySelector('[data-booking-success]')
      if (success) success.focus()
    })
  }

  initializeBookingForms()
  document.addEventListener('shopify:section:load', (event) => initializeBookingForms(event.target))

  } catch(e) { console.error(e); }
})();
})();
